import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  es: {
    "取消": 'Cancelar',
    "确定": 'Aceptar',
    "发送": 'Enviar',
    "系统通知": 'Notificación del sistema',
    "关闭": 'Cerrar',
    "图片": 'Imagen',
    "文件": 'Archivo',
    "表情": 'Emojis',
    "视频": 'Vídeo',
    "录制": 'Grabar',
    "拍照": 'Tomar foto',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;
